import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$background",
  },
  card: {
    backgroundColor: "$survey_card",
  },
  container: {
    flex: 0.7,
    alignItems: "center",
    justifyContent: "center",
  },
  circle: {
    backgroundColor: "$unfilled_percentage_circle",
  },
  cicleCorrect: {
    color: "$correct",
  },
  cicleInorrect: {
    color: "$incorrect",
  },
  text: {
    fontSize: "$quiz_score_text_size",
    fontFamily: "$quiz_score_text_style",
    textAlign: "center",
    color: "$question_text",
    fontWeight: "bold",
  },
  scoreLabel: {
    fontSize: "$quiz_score_label_size",
  },
  percentCircleContainer: {
    marginTop: "20vh",
    marginBottom: "3vh",
  },
  tiles: {
    backgroundColor: "$question_text",
  },
  tilesText: {
    color: "$survey_card",
    fontSize: "$option_text_size",
  },
  logo: {
    width: "$width_logo",
    height: "$height_logo",
  },
});
